module.exports = __webpack_public_path__ + "img/default-head.de696758.png";